var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonitericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M474.16,75V276.43H26.08c-.11-1.09-.22-1.65-.22-2.21,0-64.77-.1-129.55.17-194.32A41.68,41.68,0,0,1,30,62.64C37.5,46.79,50.91,40,68.18,40q181.64,0,363.27,0c1.16,0,2.33,0,3.5,0,12.27.56,22.51,5.19,30.44,14.81C470.28,60.79,472.45,67.78,474.16,75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M474.16,333.34c-2.57,6.27-4.19,13.17-7.9,18.67-7.92,11.77-19.94,16.38-33.94,16.37q-63.88,0-127.79,0H67.77c-17.11,0-30.15-7-37.89-22.57a30.07,30.07,0,0,1-3.31-11.64c-.46-10.29-.16-20.62-.16-31.46H474.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.58,460V434h4.87q30.64,0,61.28,0c17.57,0,28.36-10.67,28.64-28.22.06-3.62,0-7.24,0-11H326.8c0,4.77-.3,9.43.05,14C328,424,338.63,433.92,353.94,434c20.72.12,41.44,0,62.15,0h5.17v26Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitericon);
export default __webpack_public_path__ + "static/media/Moniter icon.928c5cdb20f8d2890d8ad2d9963790b1.svg";
export { ForwardRef as ReactComponent };